export interface IPFieldCheck {
  /*
   * IPFieldCheck - 현장 확인 사진 항목
   */

  // DB Fields
  uid: number;
  projectUID: number; // 프로젝트 고유값
  itemUID: number; // 종속된 IPItem의 UID
  processName: string; // 공정명
  itemName: string; // 항목명
  specName: string; // 설비(위치)명
  notice: string; // 지적사항
  improve: string; // 개선대책
  regulation: string; // 관련법규

  noticeCopiedCount: number;
  improveCopiedCount: number;
  regulationCopiedCount: number;

  isNotPrint: boolean; // 출력제외

  photoFile1: string; // 사진1 파일명
  photoFile2: string; // 사진2 파일명
  photoName1: string; // 사진1 명칭
  photoName2: string; // 사진2 명칭
  displayOrder: number; // 표시 순서
  writerUID: number; // 작성자 KISAUser UID
  entryDate: Date; // 작성 날짜
  modifyDate: Date; // 수정 날짜

  // Non DB Fields
  photoFile1Base64: string;
  photoFile2Base64: string;
}

// 초기값
export const InitializeIPFieldCheck: IPFieldCheck = {
  uid: 0,
  projectUID: 0, // 프로젝트 고유값
  itemUID: 0, // 종속된 IPItem의 UID
  processName: "", // 공정명
  itemName: "", // 항목명
  specName: "", // 설비(위치)명
  notice: "", // 지적사항
  improve: "", // 개선대책
  regulation: "", // 관련법규
  noticeCopiedCount: 0,
  improveCopiedCount: 0,
  regulationCopiedCount: 0,
  isNotPrint: false,
  photoFile1: "", // 사진1 파일명
  photoFile2: "", // 사진2 파일명
  photoName1: "", // 사진1 명칭
  photoName2: "", // 사진2 명칭
  displayOrder: 0, // 표시 순서
  writerUID: 0, // 작성자 KISAUser UID
  entryDate: new Date(), // 작성 날짜
  modifyDate: new Date(), // 수정 날짜

  photoFile1Base64: "",
  photoFile2Base64: "",
};

export interface CheckListRequest {
  userToken: string;
  id: number;
  pid: number;
  page: number;
  rowCount: number;
}
export interface FieldCheck {
  userToken: string;
  id: number;
  successHandler?: any;
}

// note 2022-02-05 SmokingScully 추가
export interface FieldCheckRequest {
  userToken: string;
  item: IPFieldCheck;
  successHandler?: any;
  failHandler?: any;
}
export interface SearchFieldCheckListRequest {
  userToken: string;
  searchWord: string;
}


